import { Helmet } from 'react-helmet-async'
import HomeTemplate from '../templates/HomeTemplate.jsx'
import DownloaderSEO from '../components/ui/DownloaderSEO.jsx'
import { PAGES, buildFAQSchema, buildHowToSchema } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'

const { title, description, canonical } = PAGES.tiktok

const faqSchema = buildFAQSchema([
  { q: 'Can I download TikTok videos as both MP3 and MP4?', a: 'Yes! FastAudio downloads TikTok audio as MP3 (128/192/320kbps) or the video as MP4 — both options appear after you paste the URL.' },
  { q: 'Is the downloaded TikTok video watermark-free?', a: 'Yes. FastAudio extracts the original audio and video stream without the TikTok watermark.' },
  { q: 'Why might a TikTok download fail?', a: 'TikTok blocks requests from some cloud server IPs. Private accounts and deleted videos also cannot be downloaded. Try again if it fails.' },
  { q: 'Does FastAudio support vm.tiktok.com short links?', a: 'Yes, standard TikTok URLs and short links (vm.tiktok.com, vt.tiktok.com) are both supported.' },
  { q: 'Do I need a TikTok account?', a: 'No account needed to download public TikTok videos.' },
])

const howToSchema = buildHowToSchema('How to Download TikTok to MP3 or MP4', [
  { title: 'Open the TikTok video', text: 'Find the video in the TikTok app or on tiktok.com.' },
  { title: 'Copy the link', text: 'Tap Share → Copy Link in the TikTok app.' },
  { title: 'Paste into FastAudio', text: 'Paste the URL — video info loads automatically.' },
  { title: 'Choose your format', text: 'Select MP3 audio (no watermark) or MP4 video quality.' },
  { title: 'Click Download', text: 'Hit ⚡ Download and save your file.' },
])

export default function TikTokDownloader() {
  const { t } = useLanguage()
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <HomeTemplate
        provider="tiktok"
        title={title}
        description={description}
        canonical={canonical}
        badge={t('tiktokBadge')}
        heading={
          <>
            {t('tiktokH1')}{' '}
            <span className="text-gradient">{t('tiktokH2')}</span>
          </>
        }
        subheading={t('tiktokSub')}
        placeholder={t('ttPlaceholder')}
      >
        <DownloaderSEO provider="tiktok" />
      </HomeTemplate>
    </>
  )
}
